import React from 'react';
import { formatEUR } from './constants';

// ─── PaymentSummary ───────────────────────────────────────────────────────────
// Panneau central de l'étape 3 : montants + historique.

const PaymentSummary = ({ ventilationTarget, totalTTC, paidAmount, paymentHistory }) => {
    const resteApres = Math.max(0, Math.round((totalTTC - paidAmount - ventilationTarget) * 100) / 100);

    return (
        <div className="flex-col" style={{ gap: 10 }}>

            {/* Montants */}
            <div className="dark-card payment-amounts-card">
                <div className="payment-amount-row bold">
                    <span>Montant à régler :</span>
                    <span>{formatEUR(ventilationTarget)}</span>
                </div>
                <div className="payment-amount-row text-muted">
                    <span>Montant payé :</span>
                    <span>{formatEUR(paidAmount)}</span>
                </div>
                <div className="payment-amount-row text-muted">
                    <span>Reste après :</span>
                    <span>{formatEUR(resteApres)}</span>
                </div>
            </div>

            {/* Historique */}
            <div className="dark-card flex-col" style={{ flexGrow: 1, minHeight: 0 }}>
                <span className="section-label">Historique de paiements :</span>
                <div className="history-list">
                    {paymentHistory.length === 0 ? (
                        <p className="text-muted history-empty">
                            Aucune transaction enregistrée
                        </p>
                    ) : (
                        paymentHistory.map((p) => (
                            <div key={p.id} className="history-item">
                                <div className="history-item-left">
                                    <span>{p.label}</span>
                                    {p.mode && (
                                        <span className="history-item-mode">{p.mode}</span>
                                    )}
                                </div>
                                <span>{formatEUR(p.amount)}</span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentSummary;
